import React, { useRef, useState } from 'react';
import { useSelector } from 'umi';
import Filter from '@/pages/dashboard/components/NewFilter';
import { setBtnPointLog } from '@/pages/dashboard/utils/utils';
import { getDateDefault } from '../../utils/dateUtils';

/**
 *
 * @param props
 * @param props:filterConfirm 筛选器确认函数
 * @param props:filterReset 筛选器重置函数
 * @param props:setFilterLoading 筛选器loading设置，透传到筛选器组件内部，获取到筛选器列表时区等数据之后，设置为false，测试才可进行页面和组件中的接口调用
 * @param props:filterInit 初始化函数，会向外部传递初始化后的筛选器值
 * @returns
 */

const ChurnNewFilter = (props: any) => {
  const { filterConfirm, filterReset, setFilterLoading, filterInit, openSticky = false, children, isHaveFilterSave, timeZone, path } = props;
  const filterValueRef = useRef<any>({
    rangeTime: {
      type: 'date',
      value: getDateDefault({timeType: 'day', timeZone, startNum: 15, endNum: 2}),
    },
  });

  const {seasonInfo} = useSelector((state: any) =>
    // 初始可能为undefied,在此加兜底
    ({
      seasonInfo: state?.dashboardSetting?.gameConfig?.season_info || {date: [],week: [],month: []},
    })
  );

  // 设置inputList
  const [inputList] = useState([
    {
      type: 'rangeDaily',
      key: 'rangeTime',
      default: getDateDefault({timeType: 'day', timeZone, startNum: 15, endNum: 2}),
      extraShortcut: seasonInfo
    },
  ]);

  const handleConfirm = (value: any) => {
    filterValueRef.current = value;
    const filterValue = {
      ...value,
      rangeTime: [
        value?.rangeTime?.[0]?.format('YYYY-MM-DD'),
        value?.rangeTime?.[1]?.format('YYYY-MM-DD')
      ]
    };
    filterConfirm?.(filterValue);

    setBtnPointLog({
      confirmButtonId: '200902001',
      pageId: '200902'
    }, filterValue);
  };

  const handleReset = (value: any) => {
    filterValueRef.current = value;
    const filterValue = {
      ...value,
      rangeTime: [
        value?.rangeTime?.[0]?.format('YYYY-MM-DD'),
        value?.rangeTime?.[1]?.format('YYYY-MM-DD')
      ]
    };
    filterReset?.(filterValue);

    setBtnPointLog({
      resetButtonId: '200902002',
      pageId: '200902'
    }, filterValue, true);
  };

  const handleInit = (value: any) => {
    filterValueRef.current = value;

    filterInit?.({
      ...value,
      rangeTime: [
        value?.rangeTime?.[0]?.format('YYYY-MM-DD'),
        value?.rangeTime?.[1]?.format('YYYY-MM-DD')
      ],
    });
    setFilterLoading(false);
  };

  return (
    <Filter
      config={props.config}
      openSticky={openSticky}
      path={path}
      value={filterValueRef.current}
      latestDateType={''}
      inputList={inputList}
      onInit={handleInit}
      onConfirm={handleConfirm}
      onReset={handleReset}
      isHaveFilterSave={isHaveFilterSave}
    >
      {
        children
      }
    </Filter>
  );
};

export default ChurnNewFilter;
